import styles from './styles.less';
import { observer } from 'mobx-react';


const StreamingNow = (props) => {
    const className = cx(styles.root, props.className);
    return (
        <div className={ className }>
            <a className={ styles.link } href='/videos/streams'>
                <div className={ styles.callout }>Streaming Live Now!</div>
                <h2 className={ styles.title }>{ props.title }</h2>
            </a>
        </div>
    );
};

StreamingNow.propTypes = {
    title: React.PropTypes.string.isRequired
};


export default observer(StreamingNow);



// WEBPACK FOOTER //
// ./src/show-index/components/streaming-now/index.js